import { useNavigate } from 'react-router-dom';
import { ButtonCore } from '@components';
import NotFoundImg from '@assets/images/404-ai.png';
import styles from './index.module.scss';
import { FC, ReactElement } from 'react';

interface IProps {
  text?: string;
  button?: ReactElement;
}
const NotFound: FC<IProps> = ({
  text = 'Page Not Found',
  button = (
    <ButtonCore type="primary" onClick={() => navigate(-1)}>
      Go Back
    </ButtonCore>
  ),
}) => {
  const navigate = useNavigate();
  return (
    <div className={styles['not_found']}>
      <div className={styles['image']}>
        <img src={NotFoundImg} alt="404 Image" />
      </div>

      <h2 className={styles['title']}>
        Sorry ...
        <br />
        {text}
      </h2>
      {button}
    </div>
  );
};

export default NotFound;
